<template>
    <fragment>
        <!-- 상단 영역 -->
        <nav class="menu-wrapper">
            <div class="menu-scroll">
                <ul>
                    <!--최근 사용 메뉴(항상 존재함)  접힘 아이콘 영역 Start -- 없애기로 함 // 2019.04.22 -->
                    <!--<li>
                        <button type="button" name="button" data-service="recently" v-bind:title="$t('HEADER.SUBMENU.RECENT_HISTORY')"><span>{{ $t('HEADER.SUBMENU.RECENT_HISTORY') }}&lt;!&ndash;최근 방문 기록&ndash;&gt;</span></button>
                    </li>-->
                    <!--최근 사용 메뉴(항상 존재함)  접힘 아이콘 영역 End -->
                    <template v-for="svc of getMenuList">
                        <li v-if="svc.svcId !=='whatap'"
                            :id="'svc' + '_' + svc.svcId"
                            v-bind:class="curSvcFoldId === '' && svc.svcId ==='gov' ? 'selected' : ''">
                            <button type="button" name="button"
                                    v-bind:data-service="svc.svcId"
                                    v-bind:title="svc.svcNm"
                                    v-on:click="setSvcFold(svc.svcId)">
                                <span v-if="getLocale === 'ko' && svc.svcId !== 'main' ">{{ svc.svcNmKo }}</span>
                                <em v-else-if="svc.svcId === 'main'" class="ci ci-main medium-" >{{ svc.svcNmJa }}</em>
                                <em v-if="svc.svcId === 'saas'" class="ci ci-service-saas"></em>
                                <em v-if="svc.svcId === 'cms'" class="ci ci-service-cms"></em>
                                <em v-if="svc.svcId === 'multicdn'" class="ci ci-service-multicdn medium-"></em>
                                <em v-if="svc.svcId === 'autosavings'" class="ci ci-service-360-auto_savings medium-"/>
                                <em v-if="svc.newYn === 'Y'" class="icon-version new"><strong>N</strong></em>
                                <em v-else-if="svc.betaYn === 'Y'" class="icon-version"><strong>B</strong></em>
                            </button>
                        </li>
                    </template>
                    <!--<li class="no-service-list">-->
                        <!--이건 어디다?-->
                        <!--<button type="button" name="button" data-service="add" class="hover-btn"><span>menu add</span></button>-->
                    <!--</li>-->
                </ul>
            </div>
            <!--우선 기능이 없어서 주석, 사용서비스만 풀어서 사용하세용-->
    <!--        <div class="setting-btn-area">-->
                <!--<div class="btn-wrap">
                    <button type="button" name="button" data-toggle="old"><span>setting</span></button>
                    <p class="pt-1">이전 버전</p>
                    &lt;!&ndash; 새버전
                    <button type="button" name="button" data-toggle="new"><span>setting</span></button>
                    <p class="pt-1">새 버전</p>
                    &ndash;&gt;
                </div>
                <div class="btn-wrap">
                    <button type="button" name="button" data-state="setting" class="hover-btn"><span>setting</span></button>
                </div>-->
    <!--        </div>-->
            <div class="service-fold">
    <!--            <button type="button" name="button" data-icon="closelist" class="hover-btn" v-on:click="setSvcFold('')"><span>close</span></button>-->
                <!--<div data-service="recently" class="with-servicename" hidden>
                    <h3>{{ $t('HEADER.SUBMENU.RECENT_HISTORY') }}&lt;!&ndash;최근 방문 기록  &#45;&#45; 없애기로 함 // 2019.04.22 &ndash;&gt;</h3>
                    <ul>
                        <li v-for="recent of recentMenuList" data-depth="off" class="one">
                            <a href="#" onclick="return false;"
                               v-bind:Class="{'selected' : ('gov' + getCurMenuURL).indexOf(recent.svcId + recent.menuUrl) > -1 }"
                               v-on:click="moveRecentMenu()">
                                <em class="service">{{recent.svcNm}}</em>
                                {{recent.menuNm}}
                            </a>

                        </li>
                    </ul>
                </div>-->
                <div v-if="svc.svcAuthTypeCd !== 'AUTH_TYPE_ROLE_030'"
                     :id="'menu' + '_' + svc.svcId"
                     v-for="svc of getMenuList"
                     :key="svc.svcId"
                     v-bind:data-service="svc.svcId"
                     v-bind:class="{'selected' : svc.svcId === 'gov' ,'whaTap' : svc.svcId === 'whatap'}"
                     hidden>
                    <h3>
                        <span v-if="getLocale === 'ko'" >{{ svc.svcNmKo || svc.svcNm }}</span>
                        <span v-else-if="getLocale === 'en'" >{{ svc.svcNmEn || svc.svcNm }}</span>
                        <span v-else-if="getLocale === 'zh'" >{{ svc.svcNmZh || svc.svcNm }}</span>
                        <span v-else-if="getLocale === 'ja'" >{{ svc.svcNmJa || svc.svcNm }}</span>
                        <em v-if="svc.newYn === 'Y'" class="icon-version new"><strong>New</strong></em>
                        <em v-else-if="svc.betaYn === 'Y'" class="icon-version"><strong>Beta</strong></em>
                    </h3>
                    <ul class="service-submenus">
                        <template v-for="(menu,i) of svc.menuList">
                            <li
                                v-if="!(menu.authTypeCd === 'AUTH_TYPE_030' || menu.menuId ==='SP900' || menu.menuId ==='SP950')"
                                :key="i"
                                data-depth="off"
                                class="one">
                                <a
                                    :class="{'selected' : ('gov' + getCurMenuURL).indexOf(svc.svcId + menu.menuUrl) > -1 && menu.menuId.startsWith('GOV')}"
                                    :href="menu.menuUrl || '#'"
                                    target="_blank"
                                    onclick="return false;"
                                    @click="moveServiceMenu(svc.svcId, menu.menuId, menu.menuUrl, menu.menuFullUrl)">
                                    <div v-if="getLocale === 'ko'">{{ menu.menuNmKo || menu.menuNm }}</div>
                                    <div v-if="getLocale === 'en'">{{ menu.menuNmEn || menu.menuNm  }}</div>
                                    <div v-if="getLocale === 'zh'">{{ menu.menuNmZh || menu.menuNm  }}</div>
                                    <div v-if="getLocale === 'ja'">{{ menu.menuNmJa || menu.menuNm  }}</div>
                                    <em
                                        v-if="menu.newYn === 'Y'"
                                        class="icon-version new "><strong class="montserrat-r ">New</strong></em>
                                    <em
                                        v-if="menu.betaYn === 'Y'"
                                        class="icon-version"><strong class="montserrat-r ">Beta</strong></em>
                                    <em
                                        v-if="menu.subMenuList"
                                        onclick="return false;"
                                        class="arrow"/>
                                </a>
                                <ul
                                    v-for="(subMenu,j) of menu.subMenuList"
                                    :key="j">
                                    <li
                                        data-depth="off">
                                        <a
                                            href="#"
                                            onclick="return false;"
                                            @click="moveServiceMenu(svc.svcId, subMenu.menuId, subMenu.menuUrl, subMenu.menuFullUrl)">

                                            <div v-show="getLocale === 'ko'">{{ $t(subMenu.menuNmKo) }}</div>
                                            <div v-show="getLocale === 'en'">{{ $t(subMenu.menuNmEn) }}</div>
                                            <div v-show="getLocale === 'zh'">{{ $t(subMenu.menuNmZh) }}</div>
                                            <div v-show="getLocale === 'ja'">{{ $t(subMenu.menuNmJa) }}</div>

                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </nav>
        <!--<p class="-h5 -breadcrumb">
            <span class="">{{ $t('SERVICE') }}</span>
            <em class="-mx-1">/</em>
            <span class="">{{$te(curLoca) ? $t(curLoca) : ''}}</span>
        </p>-->
    </fragment>
</template>


<script>
    const lnb = require('./lnb')
    export default {

        name: 'LNB',
        data: function () {
            return {
                apiUrl: `${this.urls.portalUrl}`,
                //recentMenuList: [],
                //watchedUrl: '',
                curSvcFoldId: '',
                curLoca: ''
            }
        },
        created: function() {
            //this.getRecentMenu()
        },
        mounted: function(){
            // EventBus.$on("changeLocale", e => {
            //     this.getRecentMenu()
            // });
            lnb.LNB.init();
            this.getCurrentLocation();
        },
        computed: {
            getLocale: function() {
                return this.$i18n.locale;
            },
            getMenuList: function(){
                const menuList = this.$store.state.svcMenuList;
                return menuList;
            },
            getCurMenuURL: function() {
                return '/' + this.$route.path.slice(1).split('/')[0]
            }
        },
        watch: {
            // call again the method if the route changes
            '$route' (to, from) {
                lnb.LNB.event();
                this.getCurrentLocation();
            },
            getMenuList: function() {
                let self = this
                setTimeout(function() {
                    //self.foldService()
                    lnb.LNB.event()
                }, 1);


            }
        },
        methods: {
            // 최근사용메뉴로 이동
            // moveRecentMenu: function (menu) {
            //     let url
            //     if (menu.svcId == 'gov') {
            //         this.$router.push(menu.menuUrl);
            //     } else if (menu.svcId == 'metering') {
            //         url = menu.actnUrl + '#' + menu.menuUrl
            //         location.href = url
            //     } else {
            //         url = menu.actnUrl + menu.menuUrl.substring(1)
            //         location.href = url
            //     }
            // },
            // Service Portal 메뉴 이동 Function
            // movePortal: function (menuUrl) {
            //     if (!`${this.urls.portalUrl}`.includes('nuricloud')) {
            //         location.href = `${this.urls.portalUrl}/${menuUrl.substr(1)}`
            //     } else {
            //         window.open('https://www.nuricloud.com')
            //     }
            // },
            // moveService: function(svcId, svcActnUrl) {
            //     if (svcId == 'gov') {
            //         this._route.navigate(['/dashboard'])
            //     } else if (svcId == 'whatap') {
            //         window.open(svcActnUrl)
            //     } else {
            //         location.href = svcActnUrl
            //     }
            // },
            // 최근 사용 메뉴 가져오기
            // getRecentMenu: function() {
            //     let url = `/api/users/recent/menu/${this.getLocale}`
            //
            //     this.http
            //         .get(url)
            //         .then(resp => {
            //             if(resp.data.status == 'ok') {
            //                 this.recentMenuList = resp.data.result
            //
            //                 if(this.curSvcFoldId !== ''){
            //                     this.foldService()
            //                 }
            //             }
            //         });
            // },
            // // 최근 사용 메뉴 저장
            // saveRecentMenu: function() {
            //
            //     //같은 매뉴 내에서 이동 시 저장하지 않음
            //     if(this.watchedUrl == this.getCurMenuURL) return
            //
            //     this.watchedUrl = this.getCurMenuURL
            //
            //     //요 부분 라우터 실행시 태우는걸로 변경할꺼임
            //     let apiUrl = `/api/users/recent/menu`
            //
            //     let menuInfo = {
            //         svcId : this.constants.SERVICE.GOVERNANCE,
            //         menuId : ''
            //     }
            //
            //     if(this.watchedUrl == '/dashboard') {
            //         menuInfo.menuId = 'GOV010'
            //     } else if(this.watchedUrl == '/compliance'){
            //         menuInfo.menuId = 'GOV020'
            //     } else if(this.watchedUrl == '/audit'){
            //         menuInfo.menuId = 'GOV030'
            //     } else if(this.watchedUrl == '/policy'){
            //         menuInfo.menuId = 'GOV040'
            //     } else if(this.watchedUrl == '/settings'){
            //         menuInfo.menuId = 'GOV050'
            //     }
            //
            //
            //     if(menuInfo.menuId != '') {
            //         this.http.post(apiUrl, menuInfo)
            //             .then(response => {
            //                 if(response.data.status == 'ok'){
            //                     this.getRecentMenu()
            //                 }
            //             })
            //     }
            // },
            moveServiceMenu: function(svcId, menuId, menuUrl, menuFullUrl) {
                if(svcId == this.constants.SERVICE.GOVERNANCE && menuId.startsWith("GOV")) {
                    this.$router.push(menuUrl)
                }
                else {
                    location.href = menuFullUrl
                }
                // else {if(svcId == 'osn' || svcId == 'portal'){}
                //     location.href = actnUrl + menuUrl.substr(1);
                // } else {
                //     location.href = actnUrl + '#' + menuUrl;
                // }
            },
            selectGovSvc: function() {
                let self = this
                setTimeout(function(){
                    self.$refs.menu_gov.classList.add('selected')
                }, 2000)//className = 'selected'

                //$('this.$refs.menu_gov.className = 'selected'
            },
            // Footer 다국어 변경시 새로바뀐 메뉴에 대해서 다시 열기 위해 열려있는 서비스 ID 정보 저장
             setSvcFold: function(svcId){
                this.curSvcFoldId = svcId
            },
            // foldService: function() {
            //     let curService = $(`#svc_${this.curSvcFoldId}`); // svc_ + Service ID
            //     let curMenuService = $(`#menu_${this.curSvcFoldId}`); // menu_ + Service ID
            //
            //     if (typeof (_.find(this.getMenuList, {'svcId': this.curSvcFoldId})) !== 'undefined') {
            //         curService.siblings().removeClass('selected');
            //         curService.addClass('selected');
            //
            //         curMenuService.removeAttr('hidden');
            //     }
            //     else if(this.curSvcFoldId !== ''){
            //         let firstService = $(`#svc_gov`);
            //         let firstMenuService = $(`#menu_gov`);
            //
            //         if(firstMenuService.length > 0){
            //             firstService.siblings().removeClass('selected');
            //             firstService.addClass('selected');
            //             firstMenuService.siblings().removeClass('selected');
            //             firstMenuService.removeAttr('hidden');
            //         } else {
            //         }
            //     }
            // }
            getCurrentLocation: function() {

                let curLoca ='';

                switch (this.getCurMenuURL) {
                    case '/dashboard':
                        curLoca ='MENU.DASHBOARD';
                        break;
                    case '/compliance':
                        curLoca = 'MENU.COMPLIANCE';
                        break;
                    case '/audit':
                        curLoca = 'MENU.AUDIT_HISTORY';
                        break;
                    case '/policy':
                        curLoca = 'MENU.POLICY_TEMPLATE';
                        break;
                    case '/settings':
                        curLoca = 'MENU.SETTINGS';
                        break;
                }

                this.curLoca = curLoca;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/layout/lnb/lnb.vue